import moment from "moment";
import * as yup from "yup";

export const DashboardFilterSchema = yup.object().shape({
  start_date: yup.string(),
  end_date: yup
    .string()
    .test("end_date", "End date must be greater than or equal start date", function (end_date) {
      const { start_date } = this.parent;

      if (!start_date && !end_date) return true;

      return moment(end_date).isAfter(start_date);
    }),
  language: yup.mixed(),
  keyword: yup.mixed(),
  sentiment: yup.mixed(),
  author_verified: yup.mixed(),
});
